import { markRaw } from 'vue';
import { LayerListPosition, ParcelListType, type ModuleConfigPartial } from '@maximap-base';
import {
  FertilizerPlanTypeIcon,
  HomogenousDosePlanIcon,
  SelfZoneDosePlanIcon,
  ZoneStrengthDosePlanIcon
} from '@maximap-base';
import { PlanFileType } from '@maximap-base';
import { DosePlan, PlanType } from '@maximap-base';

export const getAppConfig = {
  parcel: {
    needParcelGroups: false,
    needGeoLayerUpload: false,
    listType: ParcelListType.CARDS,
    layerListPosition: LayerListPosition.LEFT,
    needParcelLayerEditButton: false,
    needParcelSubLayerButton: false
  },
  map: {
    mapSourceURL: '',
    addedLayersNavLocation: 'left',
    layersNavLocation: 'right',
    numberOfMaps: 2,
    needSettings: false,
    needAutoMapChange: false,
    mapsOrientation: 'horizontal'
  },
  fertilizer: {
    needFilters: false,
    needAddNew: false,
    needHeader: false
  },
  plan: {
    needExpertAdvice: false,
    needFileUpload: false,
    needSidenav: false,
    needZoneDetails: false,
    needDetailsLayerChooser: false,
    needDetailsZoom: false,
    planChooserType: 'button',
    planTypeOptions: [
      {
        planType: PlanType.FERTILIZER_PLAN,
        title: 'plan.planType.fertilizerPlan',
        icon: markRaw(FertilizerPlanTypeIcon)
      }
    ],
    doseTypeOptions: [
      {
        doseType: DosePlan.HOMOGENEOUS,
        title: 'plan.dosePlan.homogeneous',
        icon: markRaw(HomogenousDosePlanIcon)
      },
      {
        doseType: DosePlan.ZONE_STRENGTH,
        title: 'plan.dosePlan.zoneStrength',
        icon: markRaw(ZoneStrengthDosePlanIcon)
      },
      {
        doseType: DosePlan.SELF_ZONE,
        title: 'plan.dosePlan.selfZone',
        icon: markRaw(SelfZoneDosePlanIcon)
      }
    ],
    availableDownloadFormats: [PlanFileType.SHP]
  }
} as ModuleConfigPartial;
